export interface LensData {
  lensType: string;
  coating: string;
  eyePower: {
    leftEye: { sphere: string; cylinder: string; axis: string };
    rightEye: { sphere: string; cylinder: string; axis: string };
  };
  hasPrescription: boolean;
  pdMeasurement?: string;
  leftPdMeasurement?: string;
  rightPdMeasurement?: string;
  coatingPrice: number;
}

const STORAGE_KEY = 'lensSelections';

export const getLensSelections = (): Record<string, LensData> => {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {}; } catch { return {}; }
};

export const getLensSelection = (cartItemId: string): LensData | null =>
  getLensSelections()[cartItemId] ?? null;

export const setLensSelection = (cartItemId: string, data: LensData) => {
  const all = getLensSelections();
  all[cartItemId] = data;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
};

export const removeLensSelection = (cartItemId: string) => {
  const all = getLensSelections();
  delete all[cartItemId];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
};

export const clearLensSelections = () => localStorage.removeItem(STORAGE_KEY);
